var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleSignOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#716fb3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.5 35.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.2,9.1c-1.5-1.5-3.4-2.3-5.5-2.3s-2.7.4-3.9,1c-1.2-2.2-2.9-4-5-5.4C29.4.9,26.5,0,23.5,0s-7.8,1.6-10.7,4.4c-2.9,2.8-4.3,6.4-4.4,10.3C3.6,15.8,0,19.9,0,24.8s1,5.6,3,7.6c2,2.1,4.8,3.2,7.7,3.2h33.3c2.2,0,4.3-.5,6.1-1.6,2.5-1.4,5.4-4.2,5.4-9.7s-2.7-8.7-6.9-10.4c0,0,.1-2.2-2.4-4.8ZM11.9,15.2h0c0-6.5,5.2-11.7,11.6-11.7s8.7,2.7,10.6,6.9l.8,1.8c0,.3.4.5.7.6.3,0,.6,0,.9-.2l1.5-1.2c.8-.6,1.7-1,2.7-1,2.3,0,4.2,1.8,4.3,4.1h0v1.3c0,.4.2.7.6.8l1.1.4c3.1,1.1,5.2,4,5.2,7.3s-3,7.3-6.9,7.7H10.5c-3.9,0-7-3.1-7-7s2.7-6.5,6.2-7l1.5-.2c.4,0,.7-.4.7-.8,0,0,0-1.7,0-1.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.5,18.5c.1.3.3.5.6.6l2.5,1c.6.2.6,0,.8,0l1-.5.5,1c.1.3.3.5.6.6l4.2,1.6c.2,3,2.1,5.6,4.9,6.7.9.3,1.8.5,2.7.5,3.1,0,6-1.9,7.1-4.9,1.5-3.9-.5-8.4-4.4-9.9-2.8-1.1-6-.4-8.1,1.7l-9.7-3.7c-.4-.2-.6,0-.8,0l-2.6,1.2c-.5.2-.8.8-.5,1.4h0l1.2,2.7ZM18.1,15.3l9.9,3.8c.4.2.9,0,1.2-.3,1.1-1.3,2.6-2.1,4.2-2s1.3.1,2,.4c2.8,1.1,4.2,4.3,3.2,7.1-1.1,2.8-4.3,4.2-7.1,3.2-2.2-.8-3.6-3-3.5-5.4h0c0-.5-.3-.9-.7-1l-4.5-1.7-.7-1.6c-.1-.3-.3-.5-.6-.6-.4-.2-2.4.7-2.4.7l-1.7-.6-.5-1.3,1.2-.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleSignOn);
export default __webpack_public_path__ + "static/media/single-sign-on.2b9b02ad0f285546056243284f697677.svg";
export { ForwardRef as ReactComponent };